import { Employee_Dashboard_Monthly_Present_Absent } from './employee-dashboard-monthly-present-absent.model';
import { ApiErrorCode } from '../service-proxies';


export class Employee_Dashboard_Monthly_Present_AbsentApiResponse implements IEmployee_Dashboard_Monthly_Present_AbsentApiResponse {
    isSuccess!: boolean;
    responseData!: Employee_Dashboard_Monthly_Present_Absent;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IEmployee_Dashboard_Monthly_Present_AbsentApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? Employee_Dashboard_Monthly_Present_Absent.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_Monthly_Present_AbsentApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Monthly_Present_AbsentApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IEmployee_Dashboard_Monthly_Present_AbsentApiResponse {
    isSuccess: boolean;
    responseData: Employee_Dashboard_Monthly_Present_Absent;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

